var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgNutritionLibrary = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 23.871,
      height: 28.195,
      viewBox: "0 0 23.871 28.195",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_17014",
      "data-name": "Group 17014",
      transform: "translate(0 0.002)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_9744",
      "data-name": "Group 9744",
      transform: "translate(6.254 0)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11362",
      "data-name": "Path 11362",
      d: "M11113.131,4029.352a5.63,5.63,0,0,1-6.327-6.323A5.63,5.63,0,0,1,11113.131,4029.352Z",
      transform: "translate(-11106.777 -4023.001)"
    })),
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_9745",
      "data-name": "Group 9745",
      transform: "translate(11.47 1.085)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11363",
      "data-name": "Path 11363",
      d: "M11199.212,4049.623c-.024,0-.048,0-.075,0a.883.883,0,0,1-.8-.955,7.422,7.422,0,0,1,2.685-5.332,6.624,6.624,0,0,1,2.393-1.255.884.884,0,0,1,.422,1.717,5.382,5.382,0,0,0-3.737,5.023A.887.887,0,0,1,11199.212,4049.623Z",
      transform: "translate(-11198.329 -4042.053)"
    })),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11364",
      "data-name": "Path 11364",
      d: "M11015.848,4131.479a5.738,5.738,0,0,0-3.144.114,13.946,13.946,0,0,1-2.507.53c-.418.049-.843.077-1.265.088-.421-.011-.844-.039-1.268-.088a14.069,14.069,0,0,1-2.5-.53,5.737,5.737,0,0,0-3.144-.114c-4.108,1.05-6.092,6.758-4.432,12.749a16.359,16.359,0,0,0,1.273,3.214c2.173,4.128,5.867,6.574,9.187,5.725a.023.023,0,0,0,.016,0,2.744,2.744,0,0,1,1.743,0,.03.03,0,0,0,.016,0c3.32.849,7.012-1.6,9.187-5.725a16.239,16.239,0,0,0,1.273-3.214C11021.945,4138.237,11019.958,4132.529,11015.848,4131.479Z",
      transform: "translate(-10996.998 -4125.141)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_11365",
      "data-name": "Path 11365",
      d: "M11007.2,4132.319l.47-.2a14.069,14.069,0,0,1-2.5-.53,5.737,5.737,0,0,0-3.144-.114c-4.108,1.05-6.092,6.758-4.432,12.749a16.359,16.359,0,0,0,1.273,3.214C10996.886,4134.785,11007.2,4132.319,11007.2,4132.319Z",
      transform: "translate(-10996.998 -4125.141)"
    }))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgNutritionLibrary, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Nutrition_library.904eb243.svg";
export { ForwardRef as ReactComponent };